import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=40a442eb&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=40a442eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a442eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40a442eb')) {
      api.createRecord('40a442eb', component.options)
    } else {
      api.reload('40a442eb', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=40a442eb&scoped=true&", function () {
      api.rerender('40a442eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yrJT3KKmu2fg/JS/comp/DocBox.vue"
export default component.exports